'use strict';

const focusHelper = require('base/components/focus');
const age = require('../common/age');

/**
 * 画面下部にクッキー同意モーダルを表示する
 */
function showConsentModal() {
    let trackingConsentData = $('.tracking-consent');
    if (!trackingConsentData.data('caonline')) {
        return;
    }

    // 年齢確認モーダルを表示する
    // クッキー同意バナーの表示方法が変わったため、関数の呼び出し箇所を変更した
    age.showConfirmAgeModal();

    let urlContent = trackingConsentData.data('url');
    let urlAccept = trackingConsentData.data('accept');
    let textClose = trackingConsentData.data('close');
    let tokenName = trackingConsentData.data('tokenname');
    let token = trackingConsentData.data('token');
    let urlClose = trackingConsentData.data('consenttrackingclose');

    const aside = document.createElement('aside');
    aside.id = 'consent-tracking';
    aside.className = 'bottom-banner';
    // consent-tracking-bodyにコンテンツアセットの内容を入れる
    aside.innerHTML =
        `<div class="cookie-consent"><div id="consent-tracking-body" class="modal-body"></div>` +
        `<div class="bottom-banner-button"><button class="affirm btn btn-block btn-dark" data-url="` +
        urlClose +
        `" >` +
        textClose +
        '</button></div></div>';
    document.body.appendChild(aside);

    // 変更前の同意ボタンを押下したときの動作
    const sendAccept = () => {
        let url = urlAccept;
        let data = {};
        data[tokenName] = token;
        $.ajax({
            url: url,
            type: 'post',
            data: data,
            dataType: 'json',
            success: function (response) {
                // 既にバナーを表示しているため処理に成功した場合は特に何もしない
            },
            error: function (err) {
                // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
    };

    $.ajax({
        url: urlContent,
        type: 'get',
        dataType: 'html',
        success: function (response) {
            $('#consent-tracking-body').html(response);
            // バナーを表示した時点で同意ボタンを押下したとみなす まだ未同意だったの場合はajax通信で同意フラグを立てる
            if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
                sendAccept();
            }
        },
        error: function () {
            $('#consent-tracking').remove();
        },
    });

    // バナーの閉じるボタンを押下した際の動作
    $('#consent-tracking button').click(function (e) {
        e.preventDefault();
        let url = $(this).data('url');
        let data = {};
        data[tokenName] = token;
        $.ajax({
            url: url,
            type: 'post',
            data: data,
            dataType: 'json',
            success: function (response) {
                // Only hide modal if the operation is successful - don't want to give a false impression
                if (response.success) {
                    $('#consent-tracking').remove();
                }
            },
            error: function (err) {
                // エラーの場合も同意バナーを閉じる
                $('#consent-tracking').remove();
                // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
        });
    });
}

module.exports = function () {
    if ($('.consent_closed').length === 0 && $('.tracking-consent').hasClass('api-true')) {
        showConsentModal();
    }

    if ($('.tracking-consent').hasClass('api-true')) {
        $('.tracking-consent').click(function () {
            showConsentModal();
        });
    }

    $('body').on('shown.bs.modal', '#consent-tracking', function () {
        $('#consent-tracking').siblings().attr('aria-hidden', 'true');
        $('#consent-tracking .affirm').focus();
    });

    $('body').on('hidden.bs.modal', '#consent-tracking', function () {
        $('#consent-tracking').siblings().attr('aria-hidden', 'false');
        $.spinner().stop();
    });

    $('body').on('keydown', '#consent-tracking', function (e) {
        let focusParams = {
            event: e,
            containerSelector: '#consent-tracking',
            firstElementSelector: '.affirm',
            lastElementSelector: '.decline',
            nextToLastElementSelector: '.affirm',
        };
        focusHelper.setTabNextFocus(focusParams);
    });
};
